import React from 'react';
import { useNavigate } from 'react-router-dom';
import SelectDateAndTimePage from './SelectDateAndTimePage';

const SelectDateAndTimePageWrapper = () => {
  const navigate = useNavigate();
  return <SelectDateAndTimePage navigate={navigate} />;
};

export default SelectDateAndTimePageWrapper;
